import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import history from '../../history';
import style from './Link.css';
import { changePath } from '../../actions';

const mapStateToProps = state => ({
  path: state.path.path
});

const mapDispatchToProps = {
  changePath: path => dispatch => {
    dispatch(changePath(path));
  }
};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class Link extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func
  };

  static defaultProps = {
    onClick: null
  };

  handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    event.preventDefault();
    if (this.props.to !== '#') {
      this.props.changePath(this.props.to);
    }
    history.push(this.props.to);
  };

  active(path) {
    if (this.props.subPaths) {
      return this.props.subPaths.split(',').includes(path);
    }
    return path === this.props.to;
  }
  render() {
    const {
      to,
      children,
      subPaths,
      path,
      changePath,
      dispatch,
      styleName,
      ...props
    } = this.props;
    return (
      <a
        className={cx(
          { [style.active]: this.active(path) },
          style.link,
          styleName
        )}
        href={to}
        {...props}
        onClick={this.handleClick}
      >
        {children}
      </a>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(style)(Link)
);



// WEBPACK FOOTER //
// ./src/components/Link/Link.js